import { render, staticRenderFns } from "./reportNakladnoy.vue?vue&type=template&id=1635840e&scoped=true&"
import script from "./reportNakladnoy.vue?vue&type=script&lang=js&"
export * from "./reportNakladnoy.vue?vue&type=script&lang=js&"
import style0 from "./reportNakladnoy.vue?vue&type=style&index=0&id=1635840e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1635840e",
  null
  
)

export default component.exports